import { BaseObject } from "@adgate/common/types/base-object.type";

export class Status extends BaseObject
{
    public static TV_CREATED:number                             = 1;
    public static TV_UPLOADED:number                            = 2;
    public static TV_PROCESSED:number                           = 3;
    public static TV_REJECTED:number                            = 4;
    public static TV_RELOAD:number                              = 5;
    public static TV_APPROVED:number                            = 6;
    public static TV_SPECERROR:number                           = 7;


    public static STREAMING_CREATIVITY_CREATED                  = 40;
    public static STREAMING_CREATIVITY_UPLOADED                 = 41;
    public static STREAMING_CREATIVITY_PROCESSED                = 42;
    public static STREAMING_CREATIVITY_REJECTED                 = 43;
    public static STREAMING_CREATIVITY_SPECERROR                = 44;
    public static STREAMING_CREATIVITY_RELOAD                   = 45;
    public static STREAMING_CREATIVITY_APPROVED                 = 46;

    public static PRODUCTION_REQUEST_CREATED:number                 = 60;
    public static PRODUCTION_REQUEST_AWAITINGSAMPLEAPPROVAL:number  = 63;

    public static PRODUCTION_VERSION_CREATED:number             = 80;

    public static PRODUCTION_REQUESTSAMPLE_APPROVED:number      = 100;
    public static PRODUCTION_REQUESTSAMPLE_REJECTED:number      = 101;


    // public static TV_COMPLETE:number                  = 98;
    // public static TV_CANCELLED:number                 = 99;

}